import {
    AutocompleteInput,
    DateInput,
    NumberInput,
    ReferenceInput,
    SelectInput,
    SimpleForm,
    TextInput
} from "react-admin";
import {CustomToolbar} from "../../components/CustomToolbar";
import {FormProps} from "../../shared/types";
import {Grid} from "@material-ui/core";
import {ReferenceInputCategoryDocument} from "../../components/reference-inputs/ReferenceInputCategoryDocument";
import {initInput} from "../../shared/utils";
import {ReferenceInputSubject} from "../../components/reference-inputs/ReferenceInputSubject";
import {ReferenceInputAccountCompany} from "../../components/reference-inputs/ReferenceInputAccountCompany";

export const DocumentForm = (props: FormProps) => {
    return (
        <SimpleForm
            {...props}
            toolbar={
                <CustomToolbar canEdit={props.canEdit} canDelete={props.canDelete}/>
            }
        >
            <Grid spacing={2} container alignItems="center" style={{width: "100%"}}>
                <Grid item xs={4}>
                    <ReferenceInputAccountCompany
                        {...initInput("company", props.fieldOptions, props.canEdit)}
                        required
                    />
                </Grid>
                <Grid item xs={4}>
                    <ReferenceInputCategoryDocument {...initInput("category_document", props.fieldOptions, props.canEdit)} />
                </Grid>
                <Grid item xs={4}>
                    <TextInput {...initInput("number_document", props.fieldOptions, props.canEdit)}
                               label="Numero documento"/>
                </Grid>
                <Grid item xs={4}>
                    <NumberInput {...initInput("amount", props.fieldOptions, props.canEdit)} label="Importo"/>
                </Grid>
                <Grid item xs={4}>
                    <DateInput {...initInput("invoice_date", props.fieldOptions, props.canEdit)}
                               label="Data documento"/>
                </Grid>
                <Grid item xs={4}>
                    <DateInput {...initInput("expiration_date", props.fieldOptions, props.canEdit)}
                               label="Data scadenza"/>
                </Grid>
                <Grid item xs={4}>
                    <ReferenceInputSubject
                        {...initInput("supplier_id", props.fieldOptions, props.canEdit)}
                        filter={{type: "supplier"}}
                        label="Fornitore"
                        required
                    />
                </Grid>
                <Grid item xs={4}>
                    <ReferenceInput
                        {...initInput("terms_payment", props.fieldOptions, props.canEdit)}
                        reference="payment-terms"
                        required
                        perPage={10000}
                    >
                        <AutocompleteInput optionText="label"/>
                    </ReferenceInput>
                </Grid>
                <Grid item xs={4}>
                    <TextInput {...initInput("notes", props.fieldOptions, props.canEdit)}
                               label="Note"/>
                </Grid>
            </Grid>
        </SimpleForm>

    )
};

